var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#172452"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3383 5.73297C12.8413 5.86776 13.0983 6.33669 12.9635 6.8398L12.0032 10.4238L13.0679 9.96397C13.6223 9.72877 14.2103 10.048 14.2103 10.6024C14.2103 10.9552 14.0255 11.2072 13.6391 11.3752L11.5008 12.2987L10.5127 15.9864H14.6923C15.1627 15.9864 15.4987 16.3224 15.4987 16.776C15.4987 17.2296 15.1627 17.5824 14.6923 17.5824H9.53672C8.75142 17.5687 8.36704 17.0905 8.52173 16.5374L9.41591 13.1992L8.58234 13.5592C8.04474 13.7944 7.43994 13.4752 7.43994 12.9208C7.43994 12.568 7.62474 12.316 8.01114 12.148L9.91828 11.3243L11.2434 6.37889C11.3739 5.89202 11.8352 5.59817 12.3383 5.73297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtc);
export default __webpack_public_path__ + "static/media/ltc.d9c561bb4f2e001ecb96156a481ebca8.svg";
export { ForwardRef as ReactComponent };